import { useContext, useMemo } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { DrawerScreen } from '@/types/screens';

const SCREENS_TO_HIDE_EXPRESS_CHECKOUT = [DrawerScreen.SAVED_CARDS, DrawerScreen.OTHER_PAYMENT_METHOD];
const SCREENS_TO_HIDE_PAYMENT_METHODS = [DrawerScreen.SAVED_CARDS, DrawerScreen.OTHER_PAYMENT_METHOD];

export const usePaymentSectionVisibility = () => {
  const {
    viewer: { screen },
  } = useContext(CheckoutContext);

  return useMemo(
    () => ({
      shouldShowExpressCheckoutByScreen: !SCREENS_TO_HIDE_EXPRESS_CHECKOUT.includes(screen as DrawerScreen),
      shouldShowPaymentMethodsByScreen: !SCREENS_TO_HIDE_PAYMENT_METHODS.includes(screen as DrawerScreen),
    }),
    [screen]
  );
};
